export default __webpack_public_path__ + "static/media/rocket.37affa25.png";